import serialize from 'serialize-javascript';

export const getServerData = () =>  {
  return JSON.parse(serialize(window.SERVER_DATA, {isJSON: true}));
}